import _extends from "@babel/runtime/helpers/extends";
import { Button, createStyles, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, makeStyles, TextField, Tooltip, useTheme } from '@material-ui/core';
import { ArrowDropDown, Close, DragHandle } from '@material-ui/icons';
import React, { useCallback, useRef, useState } from 'react';
import { renderToString } from 'react-dom/server';
import { useLocalization } from "../../hooks/index.js";
const useStyles = makeStyles(theme => {
  return createStyles({
    ListIcon: {
      paddingLeft: '0px',
      height: '32px',
      '& .MuiIconButton-label': {
        flexDirection: 'column',
        height: 'inherit',
        justifyContent: 'center',
        '& .icon-container': {
          '&:first-of-type': {
            marginBottom: '-14px'
          },
          height: '23px',
          position: 'relative',
          '& .down-arrow': {
            top: '0',
            right: '0',
            position: 'absolute',
            marginTop: '0px',
            marginRight: '-13px'
          }
        }
      }
    },
    accordion: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '15px',
      border: '2px solid',
      borderColor: theme.palette.primary.main,
      position: 'relative',
      padding: '10px',
      borderRadius: '10px',
      '& .panel-close-button': {
        position: 'absolute',
        right: '0',
        top: '0'
      }
    },
    accordionContainer: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '20px'
    },
    actionPanel: {
      display: 'flex',
      flex: 1,
      justifyContent: 'space-between'
    },
    dialog: {
      '& .MuiDialogContent-root': {
        padding: '8px 15px'
      }
    }
  });
});
const Panel = ({
  title,
  body
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-heading"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "panel-title"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#collapse1716279617835-0",
    className: "collapsed"
  }, /*#__PURE__*/React.createElement("i", {
    className: "svg"
  }), title))), /*#__PURE__*/React.createElement("div", {
    className: "panel-collapse collapse"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-body"
  }, body)));
};
const initialAccordion = {
  title: '',
  body: ''
};
export const AccordionControl = ({
  buttonProps,
  editor
}) => {
  const [open, setOpen] = useState(false);
  const [accordions, setAccordions] = useState([initialAccordion]);
  const form = useRef(null);
  const theme = useTheme();
  const classes = useStyles(theme);
  const localization = useLocalization();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = useCallback(() => {
    setAccordions([initialAccordion]);
    setOpen(false);
  }, []);
  const handleSubmit = () => {
    var _form$current;
    if (accordions.length === 0) {
      handleClose();
      return;
    }
    if (!((_form$current = form.current) !== null && _form$current !== void 0 && _form$current.reportValidity())) {
      return;
    }
    const panelGroup = renderToString( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "panel-group"
    }, accordions.map((item, index) => {
      return /*#__PURE__*/React.createElement(Panel, {
        key: index,
        title: item.title,
        body: item.body
      });
    })), /*#__PURE__*/React.createElement("p", null)));
    editor.chain().focus().insertContent(panelGroup).run();
    handleClose();
  };
  const handleClosePanel = index => {
    setAccordions(prev => {
      return prev.filter((_, i) => i !== index);
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: localization.accordionControl.title
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    className: classes.ListIcon,
    onClick: handleClickOpen
  }, buttonProps), /*#__PURE__*/React.createElement("div", {
    className: "icon-container"
  }, /*#__PURE__*/React.createElement(ArrowDropDown, {
    className: "down-arrow"
  }), /*#__PURE__*/React.createElement(DragHandle, null)), /*#__PURE__*/React.createElement("div", {
    className: "icon-container"
  }, /*#__PURE__*/React.createElement(ArrowDropDown, {
    className: "down-arrow"
  }), /*#__PURE__*/React.createElement(DragHandle, null)))), /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    className: classes.dialog,
    onClose: handleSubmit,
    "aria-labelledby": "form-dialog-title",
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "form-dialog-title"
  }, localization.accordionControl.title), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("form", {
    ref: form,
    className: classes.accordionContainer
  }, accordions.map((accordion, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: localization.accordionControl.closePanel
    }, /*#__PURE__*/React.createElement(IconButton, _extends({
      className: "panel-close-button",
      onClick: () => handleClosePanel(index)
    }, buttonProps), /*#__PURE__*/React.createElement(Close, {
      color: "error"
    }))), /*#__PURE__*/React.createElement(TextField, {
      autoFocus: true,
      margin: "dense",
      label: localization.accordionControl.title,
      type: "text",
      required: true,
      fullWidth: true,
      value: accordion.title,
      onChange: e => {
        const newAccordions = [...accordions];
        newAccordions[index] = {
          ...accordions[index],
          title: e.target.value
        };
        setAccordions(newAccordions);
      }
    }), /*#__PURE__*/React.createElement(TextField, {
      multiline: true,
      autoFocus: true,
      margin: "dense",
      label: localization.accordionControl.body,
      type: "text",
      required: true,
      fullWidth: true,
      value: accordion.body,
      onChange: e => {
        const newAccordions = [...accordions];
        newAccordions[index] = {
          ...accordions[index],
          body: e.target.value
        };
        setAccordions(newAccordions);
      }
    }));
  }))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement("div", {
    className: classes.actionPanel
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setAccordions(prev => {
      return [...prev, initialAccordion];
    }),
    title: localization.accordionControl.addPanel
  }, localization.accordionControl.addPanel), /*#__PURE__*/React.createElement("div", {
    className: "close-actions"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose
  }, localization.common.cancel), /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      handleSubmit();
    },
    color: "primary"
  }, localization.imageControl.submit))))));
};
//# sourceMappingURL=accordion-control.js.map